import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Categories from "./sections/Categories";
import FeaturedProducts from "./sections/FeaturedProducts";
import CommercialMachines from "./sections/CommercialMachines";
import ArenasNotice from "./sections/ArenasNotice";
import Pricing from "./sections/Pricing";
import NewUsed from "./sections/NewUsed";
import Inspection from "./sections/Inspection";
import Setup from "./sections/Setup";
import Safety from "./sections/Safety";
import Shipping from "./sections/Shipping";
import Faq from "./sections/Faq";
import BuyingGuides from "./sections/BuyingGuides";
import CompareBulls from "./sections/CompareBulls";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Categories />
      <FeaturedProducts />
      <CommercialMachines />
      <ArenasNotice />
      <Pricing />
      <NewUsed />
      <Inspection />
      <Setup />
      <Safety />
      <Shipping />
      <Faq />
      <BuyingGuides />
      <CompareBulls />
      <Footer />
    </div>;
}